import React from 'react';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { ButtonUI, InputUI } from '../../Interface';

const IncomingItem = ({
  incomingFilter,
  onIncomingFilterChange,
  onSearchIncomingItem,
  incomingItem,
  isIncomingBatchManaged,
  incomingBatchSn,
  onIncomingBatchSnChange,
  incomingLot,
  onIncomingLotChange,
  incomingQty,
  onIncomingQtyChange,
  onIncomingQtyBlur,
  incomingQtyUnitCode,
  onAddIncomingLine,
}) => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 1.5,
        bgcolor: 'grey.100',
        mt: 1.5,
      }}
    >
      <Box sx={{ bgcolor: 'white' }}>
        <InputUI
          fullWidth
          size="small"
          placeholder="Vonalkód / cikkszám"
          value={incomingFilter}
          onChange={(e) => onIncomingFilterChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSearchIncomingItem();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" edge="end" aria-label="Keresés" onClick={onSearchIncomingItem}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {incomingItem ? (
        <Box sx={{ mt: 1, p: 1.25, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'white' }}>
          <Typography variant="subtitle2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
            <Box component="span" sx={{ fontWeight: 700 }}>
              {incomingItem?.itemCode}
            </Box>
            {' - '}
            {incomingItem?.item?.itemName ?? incomingItem?.itemName ?? ''}
          </Typography>

          {isIncomingBatchManaged ? (
            <>
              <InputUI
                fullWidth
                size="small"
                placeholder="Sarzs"
                value={incomingBatchSn}
                onChange={(e) => onIncomingBatchSnChange(e.target.value)}
                sx={{ mt: 1 }}
              />
              <InputUI
                fullWidth
                size="small"
                placeholder="LOT szám"
                value={incomingLot}
                onChange={(e) => onIncomingLotChange(e.target.value)}
                sx={{ mt: 1 }}
              />
            </>
          ) : null}

          <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <InputUI
              name="incomingQty"
              type="number"
              size="small"
              sx={{ width: 120 }}
              inputProps={{ min: 1, step: 1 }}
              value={incomingQty}
              onChange={(e) => onIncomingQtyChange(e.target.value)}
              onBlur={onIncomingQtyBlur}
            />
            <Typography variant="body2" color="text.secondary">
              {incomingQtyUnitCode}
            </Typography>
            <ButtonUI text="Bejövő tétel rögzítése" className="bg-success" onClick={onAddIncomingLine} />
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default IncomingItem;
